import * as React from 'react';
import type { SVGProps } from 'react';
const SvgMoneyTransfer = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={34} height={34} fill='none' {...props}>
    <rect width={34} height={34} fill='#9575CD' rx={8} />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d='M9.5 14.375h9.375M12.5 20.375H14M15.875 20.375h3'
    />
    <path
      stroke='#fff'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M24.5 18.523v1.56c0 2.632-.668 3.292-3.33 3.292h-8.34c-2.662 0-3.33-.66-3.33-3.293v-6.164c0-2.633.668-3.293 3.33-3.293h6.045M23 15.125v-4.5l1.5 1.5M23 10.625l-1.5 1.5'
    />
  </svg>
);
export default SvgMoneyTransfer;
